
import { JSX } from 'react';
import './styles.css';
import Icons from 'core/data/constants/Icons';
import Images from 'core/data/constants/Images';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MotionDiv from 'core/components/Motion';

export default function Footer() {
  const { t } = useTranslation();
  return <footer className="mainFooter">
    <div className='informativeSection'>
      <MotionDiv className='logoSection'
        initial={{ opacity: 0, x: -30 }}
        viewport={{ once: false, amount: 0.2 }}>
        <h4>
          <img src={Images.LogoImage} alt="" />
          <a
            href="https://www.facebook.com/engomadoriasara"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icons.Facebook />
          </a>
        </h4>
      </MotionDiv>
      <div className="description">
        <MotionDiv className="info navigationList"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}>
          <h4>{t("footer_links")}</h4>
          <ul>
            <li>
              <Link to="/">{t("default_home")}</Link>
            </li>
            <li>
              <Link to="/#homeContactUsSection">{t("default_contacts")}</Link>
            </li>

          </ul>
        </MotionDiv>
        <MotionDiv className="info navigationList"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}>
          <h4>{t("default_services")}</h4>
          <ul>
            <li>
              <Link to="/ironing">{t("default_ironing")}</Link>
            </li>
            <li>
              <Link to="/sewing">{t("default_sewing")}</Link>
            </li>
            <li>
              <Link to="/dryCleaning">{t("dry_cleaning")}</Link>
            </li>
            <li>
              <Link to="/sofaAndCarpetCleaning">{t("sofa_and_carpet_cleaning")}</Link>
            </li>
          </ul>
        </MotionDiv>
        <MotionDiv className="info" viewport={{ once: false, amount: 0.3 }}>
          <h4>{t("default_contacts")}</h4>
          {descriptionWithIcon(Icons.Location(), t("default_shop_address"))}
          {descriptionWithIcon(Icons.CellPhone(), t("home_page_call_us_description"))}
          {descriptionWithIcon(Icons.Email(), t("default_email_address"))}
        </MotionDiv>
      </div>
      <div>
      </div>

    </div>
    <div className='attributionSection'>
      <h4>
        {t("attribution.default")}
      </h4>
      <a href='https://www.freepik.com/' target="_blank" rel="noopener noreferrer">
        <p>
          {t("attribution.freePick")}
        </p>

      </a>
    </div>
  </footer>
}

function descriptionWithIcon(icon: JSX.Element, description: string,) {
  return <div className='descriptionWithIcon'>
    {icon}
    <p>{description}</p>
  </div>;
}